import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Component from "./Component";
import Page from "./Page";
import Demo from "./Demo";
import BgGo from "./BgGo";
import User from "./User";
import Advantages from "./Advantages";
import BgBetter from "./BgBetter";
import Satisfaction from "./Satisfaction";
import VideoSection from "./VideoSection";

function Physio() {
  const location = useLocation(); // Get state from navigation
  const [activeButton, setActiveButton] = useState("better");
  const [isLargeScreen, setIsLargeScreen] = useState(() =>
      window.matchMedia("(min-width: 1280px)").matches
    );
  
    // Hook to listen for window resize and update the screen size state
    useEffect(() => {
      const mediaQuery = window.matchMedia("(min-width: 1280px)");
      const handleChange = (e) => setIsLargeScreen(e.matches);
      mediaQuery.addEventListener("change", handleChange);
  
      // Clean up the event listener on unmount
      return () => {
        mediaQuery.removeEventListener("change", handleChange);
      };
    }, []);
  

  // Scroll to the top of the page when the component is rendered
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top of the page
  }, [location.pathname]); // Only scroll to the top when the route changes

  useEffect(() => {
    if (location.state) {
      setActiveButton(location.state); // Set the active button based on the passed state
    }
  }, [location.state]);

  return (
    <div className="position-relative">
      {/* Toggle Buttons */}
      {isLargeScreen &&
      <div
        className="position-absolute top-0 end-0 upx-20 upy-5 z-2" 
        
      >
        <div
          className="btn-group uh-12 br-10 uw-70 bg-gray-light border-light-red"
          role="group"
          aria-label="Toggle Buttons"
        >
          <button
            className={`btn fw-bold bg-gray-light text-blue ufs-4 upy-1 upx-10 br-10 ${
              activeButton === "better"
                ? "bg-dark-blue text-white"
                : "bg-gray-light"
            }`}
            onClick={() => setActiveButton("better")}
          >
            Better
          </button>
          <button
            className={`btn fw-bold bg-gray-light text-blue ufs-4 upy-1 uml-2 upx-10 br-10 ${
              activeButton === "goNeo"
                ? "bg-dark-blue text-white"
                : "bg-gray-light"
            }`}
            onClick={() => setActiveButton("goNeo")}
          >
            GoNeo
          </button>
        </div>
      </div>
       }{!isLargeScreen &&
        <div
        className="position-absolute top-0 end-0 upx-20 upy-5 z-2" 
        
      >
        <div
          className="btn-group  br-20 up-3  bg-gray-light border-light-red"
          role="group"
          aria-label="Toggle Buttons"
        >
          <button
            className={`btn fw-bold bg-gray-light text-blue ufs-14 upy-1 upx-10 br-20 ${
              activeButton === "better"
                ? "bg-dark-blue text-white"
                : "bg-gray-light"
            }`}
            onClick={() => setActiveButton("better")}
          >
            Better
          </button>
          <button
            className={`btn fw-bold bg-gray-light text-blue ufs-14 upy-4 uml-2 upx-10 br-20 ${
              activeButton === "goNeo"
                ? "bg-dark-blue text-white"
                : "bg-gray-light"
            }`}
            onClick={() => setActiveButton("goNeo")}
          >
            GoNeo
          </button>
        </div>
      </div>
           }
      {/* Conditionally Render Content */}
      <div className="content">
        {activeButton === "better" && (
          <>
            <BgBetter />
            <Page />
            <Component />
            <Demo />
          </>
        )}
        {activeButton === "goNeo" && (
          <>
            <BgGo />
            <User />
            <Advantages />
            <VideoSection />
            <Satisfaction />
          </>
        )}
      </div>
    </div>
  );
}

export default Physio;
